import { render, staticRenderFns } from "./ErrorReporter.vue?vue&type=template&id=9f6db836&"
import script from "./ErrorReporter.vue?vue&type=script&lang=js&"
export * from "./ErrorReporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports